var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetworkEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M3.265 16.528H1.222C.548 16.528 0 15.981 0 15.307V9.85c0-.676.548-1.224 1.222-1.224h2.043c.675 0 1.221.548 1.221 1.224v5.457c0 .674-.546 1.221-1.221 1.221",
    transform: "translate(-360 -1109) translate(360 1109)"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M9.011 16.528H6.97c-.676 0-1.224-.547-1.224-1.221V6.973c0-.675.548-1.222 1.224-1.222H9.01c.676 0 1.223.547 1.223 1.222v8.334c0 .674-.547 1.221-1.223 1.221M14.759 16.528h-2.041c-.676 0-1.224-.547-1.224-1.221V4.098c0-.675.548-1.223 1.224-1.223h2.04c.677 0 1.224.548 1.224 1.223v11.209c0 .674-.547 1.221-1.223 1.221M20.507 16.528h-2.042c-.675 0-1.223-.547-1.223-1.221V1.223C17.242.548 17.79 0 18.465 0h2.042c.675 0 1.223.548 1.223 1.223v14.083c0 .675-.548 1.222-1.223 1.222",
    transform: "translate(-360 -1109) translate(360 1109)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkEmpty);
export default __webpack_public_path__ + "static/media/icon-network-empty.c5bf09799be3bf61de40bd26c509fa72.svg";
export { ForwardRef as ReactComponent };